export enum FlatRateSettlementType {
  LICENSE = 'LICENSE',
  TRAVEL_EXPANSES = 'TRAVEL_EXPANSES',
  TRAINING = 'TRAINING',
  OTHER = 'OTHER',
}
